import React, { FC, ChangeEvent } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';

import styles from '../../experience.module.scss';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

type IForeignDescriptionProps = Omit<UseControllerProps, 'name'> & {
  prefixName: string;
};

const maxLength = 60;

const ForeignDescription: FC<IForeignDescriptionProps> = ({ prefixName, ...props }) => {
  const placeholder =
    '해외에서 어떤 경험을 했는지 간단히 입력해 주세요.\n(예시. 교환학생, 어학연수, 워킹홀리데이, 해외근무)';

  const name = `${prefixName}.description`;
  const { field } = useController({ name, ...props });
  const length = field.value?.length ?? 0;

  //한글 입력시 maxLength 초과되는 이슈로 인해서 onChange 이벤트 추가
  const onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    if (e.target.value.length > maxLength) {
      return;
    }

    field.onChange(e.target.value);
  };

  return (
    <div className={cx('activityWrap')}>
      <div className={cx('activityTitle')}>내용</div>

      <div className={cx('textareaWrap')}>
        <textarea {...field} placeholder={placeholder} maxLength={maxLength} rows={4} onChange={onChange} />
        <div className={cx('infoText')}>
          최대 글자수 : <span className={cx('value')}>{length}</span> / 60
        </div>
      </div>
    </div>
  );
};

export default ForeignDescription;
